import { Alert } from "@mui/material";
import React from "react";
const Notifications = () => {
  return (
    <Alert
      role="alert"
      icon={false}
      severity="warning"
      className="d-flex py-0 font-weight-bold justify-content-center align-items-center text-uppercase"
    >
      We actively encourage women to apply for the open job positions
    </Alert>
  );
};

export default Notifications;
